import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseAdvice = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6666 3.83337L3.33325 13.1667M3.33325 3.83337L12.6666 13.1667",
		stroke: "#DFCBF5",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCloseAdvice;
